import React from "react";
import {
  DescriptionOutlined,
  HomeOutlined,
  TrendingUp,
  MonetizationOnOutlined,
  HeadphonesOutlined,
  CalendarMonth,
  Description,
  Home,
  RemoveShoppingCart,
  RemoveShoppingCartOutlined,
  SupportAgent,
  SupportAgentOutlined,
  CallOutlined,
  AddCircle,
  AddCircleOutline,
  CheckCircle,
  Error,
  Warning,
  Close,
  ChevronLeft,
  ChevronRight,
  Edit,
  Check,
  ErrorOutline,
  WarningAmber,
  CheckCircleOutline,
  ContentCopy,
  DashboardOutlined,
  UploadFileRounded,
  CachedOutlined,
} from "@mui/icons-material";
import { ConnectIcon } from "./custom";

import { SxProps, Theme } from "@mui/material/styles";
import { AtIconProps, IconName } from "./at-icon.types";

const iconList: Record<
  IconName,
  React.ComponentType<{
    className?: string;
    sx?: SxProps<Theme>;
  }>
> = {
  "home-filled": Home,
  "home-outlined": HomeOutlined,
  "description-filled": Description,
  "description-outlined": DescriptionOutlined,
  "remove-shopping-cart-filled": RemoveShoppingCart,
  "remove-shopping-cart-outlined": RemoveShoppingCartOutlined,
  "support-agent-filled": SupportAgent,
  "support-agent-outlined": SupportAgentOutlined,
  "trending-up": TrendingUp,
  "upload-file-rounded": UploadFileRounded,
  "monetization-on-outlined": MonetizationOnOutlined,
  "dashboard-outlined": DashboardOutlined,
  "call-outlined": CallOutlined,
  headphones: HeadphonesOutlined,
  calendar: CalendarMonth,
  "add-circle-outlined": AddCircleOutline,
  "add-circle-filled": AddCircle,
  "check-circle": CheckCircle,
  "check-circle-outline": CheckCircleOutline,
  connect: ConnectIcon,
  check: Check,
  error: Error,
  "error-outline": ErrorOutline,
  warning: Warning,
  "warning-amber": WarningAmber,
  close: Close,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  edit: Edit,
  copy: ContentCopy,
  loading: CachedOutlined,
};

const sizeMap = {
  small: 20,
  medium: 24,
  large: 32,
};

export const getIcon = ({
  name,
  size = "medium",
  className = "",
}: AtIconProps) => {
  const IconComponent = iconList[name];

  if (!IconComponent) {
    console.warn(
      `Icon "${name}" not found. Available icons: ${Object.keys(iconList).join(", ")}`,
    );
    return null;
  }

  // Calculate final size
  let finalSize: string | number;

  if (typeof size === "number") {
    // Custom numeric size (pixels)
    finalSize = size;
  } else if (size === "small" || size === "medium" || size === "large") {
    // Predefined size
    finalSize = sizeMap[size];
  } else {
    // Responsive CSS units (rem, em, %, etc.)
    finalSize = size;
  }

  const combinedClassName = `${className}`.trim();

  return React.createElement(IconComponent, {
    className: combinedClassName,
    sx: {
      fontSize: typeof finalSize === "number" ? `${finalSize}px` : finalSize,
      width: typeof finalSize === "number" ? `${finalSize}px` : finalSize,
      height: typeof finalSize === "number" ? `${finalSize}px` : finalSize,
      display: "inline-block",
      verticalAlign: "middle",
    },
  });
};
